<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="goToUserList">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }}
            <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loadingForm"></v-progress-linear>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="goToUserList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- prepare form data -->
        <v-form ref="form" lazy-validation v-model="valid" class="ma-5 pa-5">

            <v-layout wrap="true">
                <v-flex xs12 md5>
                    <v-autocomplete v-model="select" :rules="requiredRule" :loading="loading" :items="userList" :search-input.sync="search" no-filter clearable return-object label="User" placeholder="ค้นหาชื่อ" required />
                </v-flex>
            </v-layout>
            <v-layout wrap="true">
                <v-flex xs12 md5 text-right>
                    <v-btn d-flex color="blue darken-1" text @click="goToUserList"> Cancel </v-btn>
                    <v-btn color="blue darken-1" text @click="submit">
                        OK
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import setProgramInfo from "../data/setProgramInfo";
import bqGetUserList from "../data/bqGetUserList";
import bqGetCoachListByProgramId from "../data/bqGetCoachListByProgramId";
export default {
    name: 'ProgramManagementCoachForm',
    metaInfo: {
        title: 'Program Management Coach Form'
    },
    data() {
        return {
            select: null,
            search: null,
            loading: false,
            loadingForm: false,
            userList: [],
            editedItem: {
                uid: "",
            },
            defaultItem: {
                uid: "",
            },
            dialog: false,
            title: "Add coach",

            valid: false,
            requiredRule: [
                v => !!v
            ],
            adminListResult: [],
            adminList: [],
            adminProgram: []
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loadingForm = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
        ]),
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        select(value) {
            this.$emit("input", value ? value.value : null);
        },
        search(query) {
            if (query && (!this.select || this.select.text !== query)) {
                this.querySearch(query);
            } else {
                this.userList = [];
            }
        },
    },
    methods: {
        initialize() {
            if ( this.isSuperAdmin || this.isChallengeAdmin ) {
                (async () => {
                    this.adminListResult = await bqGetCoachListByProgramId(this.id);
                    this.adminListResult.forEach((v) => {
                        this.adminList[v.uid] = 1;
                        this.adminProgram.push(v.uid);
                    });
                    this.loadingForm = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        submit() {
            (async () => {
                await this.$refs.form.validate();
                if (this.valid) {
                    (async () => {
                        this.loadingForm = true;
                        this.editedItem.updatedDate = new Date();
                        this.editedItem.updatedBy = this.loggedInUserId;
                        //get current coach and add new
                        this.adminProgram.push(this.select.value);
                        this.editedItem.coachList = this.adminProgram;
                        await setProgramInfo(this.editedItem, this.id);
                        setTimeout(() => {
                            this.dialog = true;
                        }, "3000");
                        
                    })();
                }
            })();
        },
        close() {
            this.dialog = false;
        },
        querySearch(query) {
            (async () => {
                if (query) {
                    const userListResult = await bqGetUserList(query);
                    const userArray = [];
                    userListResult.forEach((user) => {
                        if( !this.adminList[user.uid] && user.uid != this.loggedInUserId ){
                            let displayText = user.phoneNumber ? user.phoneNumber : user.email;
                            if(displayText.startsWith('line-')){
                                displayText = 'Line';
                            }
                            userArray.push({
                                value: user.uid,
                                text: user.name + " (" + displayText + ")"
                            });
                        }
                    });
                    this.userList = userArray;
                }
            })();
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToUserList() {
            this.$router.go(`-1`);
        }
    },
};
</script>
